var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Search"},[_c('div',{staticClass:"Search-inner"},[_vm._t("Search-col")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }